import React from "react";
import { AutocompleteInput, ReferenceInput, SelectInput } from "react-admin";
import { getProfessorRecordText } from "./_fieldsHelper";
import { employeeRequests } from "api/employeeApi";

const EmployeeInput = ({
  source,
  label = "Служител",
  filters = {},
  fullWidth = false,
  autocomplete = true,
  validate = null,
  readonly = false,
  disabled = false,
  alwaysOn = false,
  style,
  onChange,
  reference = employeeRequests.getEmployeesSelect(),
}) => {
  return (
    <ReferenceInput
      source={source}
      reference={reference}
      fullWidth={fullWidth}
      filter={filters}
      alwaysOn={alwaysOn}
      readOnly={readonly}
    >
      {autocomplete ? (
        <AutocompleteInput
          label={label}
          optionValue="id"
          optionText={getProfessorRecordText}
          filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          fullWidth={fullWidth}
          validate={validate}
          style={style}
          onChange={onChange}
          disabled={disabled}
        />
      ) : (
        <SelectInput
          label={label}
          optionText={getProfessorRecordText}
          onChange={onChange}
        />
      )}
    </ReferenceInput>
  );
};

export default EmployeeInput;
